/**
 * Chain Option is now a native <select> dropdown on desktop instead of the
 * custom clickable box (Material and Purity keeps the boxes).
 *
 * The custom picker boxes (assets/craft-picker.css .kg-craft-picker) still
 * exist in the DOM (just hidden for Chain Option) because swatch.liquid's own
 * script reads each picker's ".active" item to compute per-option prices
 * (e.g. the price shown next to each gold purity choice). Since the user no
 * longer clicks that hidden box, we mirror the dropdown's selection onto it
 * here so those price calculations keep reflecting the real chain length.
 */
(function () {
  'use strict';

  function labelMatches(labelEl, name) {
    if (!labelEl) return false;
    return labelEl.textContent.trim().toUpperCase() === name.trim().toUpperCase();
  }

  function syncHiddenPicker(select, optionName) {
    var pickers = document.querySelectorAll('.kg-craft-picker');
    for (var i = 0; i < pickers.length; i++) {
      var picker = pickers[i];
      var label = picker.querySelector('.kg-craft-picker__label');
      if (!labelMatches(label, optionName)) continue;

      var items = picker.querySelectorAll('.kg-craft-picker__item');
      items.forEach(function (item) {
        var isMatch = item.getAttribute('data-value') === select.value;
        item.classList.toggle('active', isMatch);
      });
    }
  }

  function bind(wrap) {
    if (wrap._chainDropdownBound) return;
    wrap._chainDropdownBound = true;

    var select = wrap.querySelector('select.single-option-selector');
    if (!select) return;

    var optionName = wrap.getAttribute('data-option-name') || '';

    select.addEventListener('change', function () {
      syncHiddenPicker(select, optionName);
    });

    // Keep it correct on initial load too.
    syncHiddenPicker(select, optionName);
  }

  function init() {
    document.querySelectorAll('.dd_wrap[data-option-handle="chain-option"]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
